<div class="bulk-change-contract-status-modal">
  <p-dialog
    [(visible)]="visible"
    [modal]="true"
    [breakpoints]="{ '960px': '75vw', '768px': '95vw' }"
    [dismissableMask]="true"
    [style]="{ width: '600px', 'max-height': '90vh' }"
    [draggable]="false"
    [resizable]="false"
    [closable]="true"
    [closeOnEscape]="true"
    (onHide)="onDialogHide()"
  >
    <ng-template pTemplate="header">
      <div class="modal-header">
        <h2 class="modal-title">Change Contract Status</h2>
      </div>
    </ng-template>

    <div class="modal-content">
      <p class="selection-summary">
        Updating <strong>{{ contractIds.length }}</strong>
        contract{{ contractIds.length === 1 ? '' : 's' }}.
      </p>

      <div *ngIf="serverError" class="server-error">
        {{ serverError }}
      </div>

      <form [formGroup]="form" class="form">
        <div class="row">
          <div class="col-12">
            <app-input-field
              label="Status"
              [type]="InputFieldType.Dropdown"
              [options]="statusOptions"
              [form]="form"
              [controlName]="'status'"
              placeholder="Select Status"
              optionLabel="label"
              optionValue="value"
              [showFilter]="true"
            ></app-input-field>
          </div>

          <div class="col-12">
            <app-input-field
              label="Fund Status"
              [type]="InputFieldType.Dropdown"
              [options]="fundStatusOptions"
              [form]="form"
              [controlName]="'fund_status'"
              placeholder="Select Fund Status"
              optionLabel="label"
              optionValue="value"
              [showFilter]="true"
            ></app-input-field>
          </div>

          <div class="col-12">
            <app-input-field
              label="Note (Optional)"
              [type]="InputFieldType.TextArea"
              [form]="form"
              [controlName]="'note'"
              placeholder="Enter a reason for this change"
            ></app-input-field>
          </div>

          <div class="col-12" *ngIf="hasNoSelectionError">
            <small class="validation-error">
              Select at least one of status or fund status.
            </small>
          </div>
        </div>
      </form>
    </div>

    <ng-template pTemplate="footer">
      <div class="modal-footer">
        <button
          type="button"
          class="cancel-btn medium"
          (click)="closeModal()"
          [disabled]="isLoadingSubmit"
        >
          Cancel
        </button>
        <button
          type="button"
          class="custom-btn medium"
          (click)="onSubmit()"
          [disabled]="form.invalid || isLoadingSubmit || !contractIds.length"
        >
          Update Status
          <i *ngIf="isLoadingSubmit" class="fa-spin fas fa-spinner ms-2"></i>
        </button>
      </div>
    </ng-template>
  </p-dialog>
</div>
